export const isGzipSupported = (): boolean => typeof CompressionStream !== 'undefined';

export async function compressGzip(data: string): Promise<ArrayBuffer> {
  const stream = new Blob([data]).stream().pipeThrough(new CompressionStream('gzip'));

  return await new Response(stream).arrayBuffer();
}
